module.exports = __webpack_public_path__ + "758da481e79dfe206c59ff5abeb64847.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/banner_frame_moderator.png
// module id = 183
// module chunks = 0